import { AnchorHTMLAttributes } from 'react';
import { clsx } from 'clsx';
import { phoneForFrontend, phoneForLink } from '@/utils/strings';
import s from './PhoneLink.module.scss';

interface Props extends AnchorHTMLAttributes<HTMLAnchorElement> {
  phone?: string | null;
  codeIsFour?: boolean;
}

export const PhoneLink = ({ phone, className, codeIsFour, ...props }: Props) => {
  if (!phone) return null;

  return (
    <a
      className={clsx(s.phone, className)}
      href={`tel:${phoneForLink(phone)}`}
      {...props}
    >
      {phoneForFrontend(phone, codeIsFour)}
    </a>
  );
};